import type { TiposSeleccionFiltroStock } from "@/hooks/Api/Articulos";

interface IndicadoresCantidadesProps {
	readonly data: CantidadesStock;
	readonly setFiltroStock: (value: TiposSeleccionFiltroStock) => void;
}
export function IndicadoresCantidades(props: IndicadoresCantidadesProps) {
	const { data } = props;

	const clickTodos = () => { props.setFiltroStock("todo"); };
	const clickMinimo = () => { props.setFiltroStock("minimo"); };
	const clickRoturaStock = () => { props.setFiltroStock("roturaStock"); };
	const clickOFs = () => document.querySelector("#datatableOrdenes")?.scrollIntoView({ behavior: "smooth" });

	return (
		<div className="contenedorIndicadores">
			<div onClick={clickTodos} className="piher-bg clicable">
				<h2>Todos</h2>
				<h1>{data.todos}</h1>
				<img src="/img/icons/arrowright.svg" className="arrow-icon" alt="Ver más" />
			</div>
			<div onClick={clickMinimo} className="piher-bg clicable">
				<h2>Bajo mínimo</h2>
				<h1>{data.bajoMinimo}</h1>
				<img src="/img/icons/arrowright.svg" className="arrow-icon" alt="Ver más" />
			</div>
			<div onClick={clickRoturaStock} className="piher-bg clicable">
				<h2>Rotura de stock</h2>
				<h1>{data.roturaStock}</h1>
				<img src="/img/icons/arrowright.svg" className="arrow-icon" alt="Ver más" />
			</div>
			<div onClick={clickOFs} className="piher-bg clicable">
				<h2>Órdenes de fabricación</h2>
				<h1>{data.ofCount}</h1>
				<img src="/img/icons/arrowright.svg" className="arrow-icon" alt="Ver más" />
			</div>
		</div>
	);
}



export interface CantidadesStock {
	todos: number | string;
	bajoMinimo: number | string;
	roturaStock: number | string;
	ofCount: number | string;
}
